exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-name[data-v-09d073bf] {\n  /*font-weight: bold;*/\n}", ""]);

// exports
